export default "__VITE_ASSET__624cafb0__"